import Icon from '../components/Icon.vue'

Icon.register({
  'comment-medical': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32c141.4 0 256 93.1 256 208s-114.6 208-256 208h-0.5c-30.5 0-78.4-8.7-106.9-19.4-24.6 19.6-74.3 51.4-140.6 51.4-4.4 0-8-3.6-8-8 0-1.8 1-4.2 2.2-5.5 0.5-0.5 42.3-45.5 54.8-95.8-35.6-35.7-57-81.2-57-130.7 0-114.9 114.6-208 256-208zM352 264v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-medical.js
// module id = 1226
// module chunks = 0